import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "phone-number-container bsp-page" }
const _hoisted_2 = {
  key: 0,
  class: "phone-number-loaded bsp-page__content"
}
const _hoisted_3 = {
  class: "bsp-business-profile-section",
  "aria-label": "Business profile settings"
}
const _hoisted_4 = { class: "bsp-profile-layout" }
const _hoisted_5 = { class: "bsp-profile-preview" }
const _hoisted_6 = { class: "bsp-profile-preview__heading" }
const _hoisted_7 = { class: "bsp-profile-preview__image" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "bsp-profile-preview__content" }
const _hoisted_10 = { class: "bsp-profile-preview__phone" }
const _hoisted_11 = { class: "bsp-profile-form__heading" }
const _hoisted_12 = { class: "bsp-form-grid" }
const _hoisted_13 = { class: "bsp-repeatable-field" }
const _hoisted_14 = { class: "bsp-repeatable-field__heading" }

import { useRouter, useRoute } from 'vue-router'
import AuthService from '../services/AuthService/AuthService'
import { computed, onMounted, ref, watch } from 'vue'
import SpinnerLoader from '../components/loaders/SpinnerLoader.vue'
import { User } from '../services/AuthService/types'
import { Establishment } from '../services/EstablishmentService/types'
import { PhoneNumber, WhatsappBusinessProfile } from '../services/AccountService/types'
// import AccountService from '../services/AccountService/AccountService'
import { POSITION, useToast } from 'vue-toastification'
import EstablishmentService from '@/services/EstablishmentService/EstablishmentService'
import AccountService from '@/services/AccountService/AccountService'
import MetaService from '@/services/MetaService/MetaService'
import BspPageHeader from '@/components/BspPageHeader.vue'
import { AButton, AIcon, AInput, ASelector, ATag } from '@adereso-ai/vue-components'
// import MetaService from '@/services/MetaService/MetaService'


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessProfileView',
  setup(__props) {


const router = useRouter()
const route = useRoute()
const toast = useToast()

const loading = ref(true)
const saving = ref(false)
const profileImageFailed = ref(false)
const currentUser = ref<User | undefined>(undefined)
const currentEstablishment = ref<Establishment | undefined>(undefined)
// const establishmentName = ref('')
const phoneNumber = ref<PhoneNumber | undefined>(undefined)

const businessProfile = ref<WhatsappBusinessProfile | undefined>(undefined)

watch(
  () => businessProfile.value?.profile_picture_url,
  () => {
    profileImageFailed.value = false
  }
)

const businessCategories = [
  { title: 'Professional services', value: 'PROF_SERVICES' }
]

const profileBreadcrumbs = computed(() => [
  {
    title: 'WhatsApp Accounts',
    icon: 'tabler:brand-whatsapp',
    to: { name: 'whatsapp-business-accounts' }
  },
  {
    title: 'Account',
    to: { name: 'whatsapp-business-account', params: { wabaId: String(route.params.wabaId) } }
  },
  {
    title: phoneNumber.value?.verified_name || 'Phone number',
    to: {
      name: 'phone-number',
      params: {
        wabaId: String(route.params.wabaId),
        phoneNumberId: String(route.params.phoneNumberId)
      }
    }
  },
  { title: 'Business profile', disabled: true }
])

async function saveBusinessProfile () {
  if (businessProfile.value) {
    saving.value = true
    const metaService = await MetaService.getInstance()
    const phoneNumberId = route.params.phoneNumberId as string
    const wabaId = route.params.wabaId as string
    try {
      await metaService.updateBusinessProfile(wabaId, phoneNumberId, businessProfile.value)
      toastSuccess('Business Profile Saved')
    } catch (error) {
      toastError('Error saving Business Profile')
    }
    saving.value = false
  }
}

async function getEstablishment () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const establishment = await establishmentService.getCurrentEstablishment()
    currentEstablishment.value = establishment
  } catch (error) {
    // do nothing
  }
}

async function getCurrentUser () {
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  if (authService.currentUser.value == null) {
    router.push({ name: 'login', query: route.query })
  }
}

async function getphoneNumber (wabaId: string, phoneNumberId: string) {
  try {
    const accountService = await AccountService.getInstance()
    phoneNumber.value = await accountService.getphoneNumber(wabaId, phoneNumberId)
  } catch {
    toastError('Error getting phone number')
  }
}

async function getBusinessProfile (wabaId: string, phoneNumberId: string) {
  try {
    const metaService = await MetaService.getInstance()
    const response = await metaService.getBusinessProfile(wabaId, phoneNumberId)
    businessProfile.value = response.data[0]
  } catch {
    toastError('Error getting phone number')
  }
}

onMounted(async () => {
  await router.isReady()

  await getCurrentUser()

  await getEstablishment()

  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string

  if (phoneNumberId && wabaId) {
    await getphoneNumber(wabaId, phoneNumberId)
    await getBusinessProfile(wabaId, phoneNumberId)
  } else {
    router.push({ name: 'home' })
  }

  loading.value = false
})

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}

function toastSuccess (successMessage: string) {
  try {
    toast.success(String(successMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value && phoneNumber.value && businessProfile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BspPageHeader, {
            breadcrumbs: profileBreadcrumbs.value,
            title: "Business profile",
            description: `Public information associated with ${phoneNumber.value.display_phone_number}.`,
            eyebrow: "WhatsApp presence",
            icon: "tabler:building-store"
          }, {
            actions: _withCtx(() => [
              _createVNode(_unref(AButton), {
                color: "blue",
                "prepend-icon": "tabler:device-floppy",
                loading: saving.value,
                onClick: saveBusinessProfile
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode(" Save profile ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ]),
            meta: _withCtx(() => [
              _createVNode(_unref(ATag), {
                text: phoneNumber.value.verified_name,
                color: "brand",
                type: "secondary"
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["breadcrumbs", "description"]),
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("aside", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "bsp-profile-preview__eyebrow" }, "Preview"),
                    _createElementVNode("h2", null, "How customers will see your business")
                  ], -1)),
                  _createVNode(_unref(ATag), {
                    text: "WhatsApp",
                    color: "success",
                    type: "secondary",
                    "prepend-icon": "tabler:brand-whatsapp"
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (businessProfile.value.profile_picture_url && !profileImageFailed.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: businessProfile.value.profile_picture_url,
                        alt: `Photo of ${businessProfile.value.about || phoneNumber.value.verified_name}`,
                        onError: _cache[0] || (_cache[0] = ($event: any) => (profileImageFailed.value = true))
                      }, null, 40, _hoisted_8))
                    : (_openBlock(), _createBlock(_unref(AIcon), {
                        key: 1,
                        icon: "tabler:building-store",
                        color: "primary",
                        size: "36",
                        "with-container": ""
                      }))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h3", null, _toDisplayString(businessProfile.value.about || phoneNumber.value.verified_name), 1),
                  _createElementVNode("p", null, _toDisplayString(businessProfile.value.description || 'Add a description to introduce the business.'), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(AIcon), {
                    icon: "tabler:phone",
                    size: "18"
                  }),
                  _createElementVNode("div", null, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, "Contact phone number", -1)),
                    _createElementVNode("strong", null, _toDisplayString(phoneNumber.value.display_phone_number), 1)
                  ])
                ])
              ]),
              _createElementVNode("form", {
                class: "bsp-profile-form",
                onSubmit: _withModifiers(saveBusinessProfile, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                    _createElementVNode("h2", null, "Business information"),
                    _createElementVNode("p", null, "Complete the public information that will appear in WhatsApp.")
                  ], -1)),
                  _createVNode(_unref(ATag), {
                    text: "Public",
                    color: "blue",
                    type: "secondary",
                    "prepend-icon": "tabler:world"
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(AInput), {
                    modelValue: businessProfile.value.about,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((businessProfile.value.about) = $event)),
                    label: "Public name",
                    placeholder: "Business name"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(AInput), {
                    modelValue: businessProfile.value.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((businessProfile.value.email) = $event)),
                    type: "email",
                    label: "Contact email",
                    placeholder: "contact@company.com"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(_unref(AInput), {
                  modelValue: businessProfile.value.address,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((businessProfile.value.address) = $event)),
                  label: "Address",
                  placeholder: "Business address"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(AInput), {
                  modelValue: businessProfile.value.description,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((businessProfile.value.description) = $event)),
                  type: "textarea",
                  label: "Description",
                  placeholder: "Briefly describe the business",
                  rows: 3,
                  "max-rows": 5,
                  "show-counter": "",
                  "max-length": 256
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(AInput), {
                  modelValue: businessProfile.value.profile_picture_url,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((businessProfile.value.profile_picture_url) = $event)),
                  type: "url",
                  label: "Profile image URL",
                  placeholder: "https://..."
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                      _createElementVNode("h3", null, "Websites"),
                      _createElementVNode("p", null, "You can publish up to two links.")
                    ], -1)),
                    (businessProfile.value.websites.length < 2)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 0,
                          variant: "text",
                          size: "small",
                          "prepend-icon": "tabler:plus",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (businessProfile.value.websites.push('')))
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode(" Add website ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessProfile.value.websites, (website, websiteIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "bsp-inline-field",
                      key: websiteIndex
                    }, [
                      _createVNode(_unref(AInput), {
                        modelValue: businessProfile.value.websites[websiteIndex],
                        "onUpdate:modelValue": ($event: any) => ((businessProfile.value.websites[websiteIndex]) = $event),
                        type: "url",
                        label: `Website ${websiteIndex + 1}`,
                        placeholder: "https://company.com"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
                      _createVNode(_unref(AButton), {
                        icon: "tabler:trash",
                        color: "red",
                        variant: "text",
                        size: "small",
                        "help-text": "Delete website",
                        onClick: ($event: any) => (businessProfile.value.websites.splice(websiteIndex, 1))
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128))
                ]),
                _createVNode(_unref(ASelector), {
                  modelValue: businessProfile.value.vertical,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((businessProfile.value.vertical) = $event)),
                  items: businessCategories,
                  "item-title": "title",
                  "item-value": "value",
                  label: "Business category"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(AInput), {
                  modelValue: businessProfile.value.profile_picture_handle,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((businessProfile.value.profile_picture_handle) = $event)),
                  label: "New image handle",
                  placeholder: "Handle provided by Meta",
                  "help-text": "Use this field when the image was previously uploaded to Meta."
                }, null, 8, ["modelValue"])
              ], 32)
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
  ]))
}
}

})